import { render } from "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=template&id=b5f40e7a"
import script from "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=script&lang=js"
export * from "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=script&lang=js"

import "./AvisoPrivacidadAutorizoDescuento.vue?vue&type=style&index=0&id=b5f40e7a&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__